const ContactIcon = () => {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="none"
                  viewBox="0 0 25 25"
            >
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="1.5"
                        d="M17.75 21h-10c-3 0-5-1.5-5-5V9c0-3.5 2-5 5-5h10c3 0 5 1.5 5 5v7c0 3.5-2 5-5 5z"
                  ></path>
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="1.5"
                        d="M17.75 9.5L14.62 12c-1.03.82-2.72.82-3.75 0L7.75 9.5"
                  ></path>
            </svg>
      );
};

export default ContactIcon;
